export default {
  VIEW_EMAIL_CREATE: "view.ContentsEmailCreate",
  VIEW_EMAIL_EDIT: "view.ContentsEmailEdit",
  VIEW_EMAIL_INDEX: "view.ContentsEmailIndex",
  VIEW_EMAIL_SHOW: "view.ContentsEmailShow",
};
